import { ReactComponent as AddListIcon } from "Components/_Shared/Icons/Assets/add-list.svg";
import { UnstyledLink } from "Components/_Shared/Routing/UnstyledLink";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { Button } from "./Button";

export const NewAnalysisButton = () => {
  const { t } = useResource();
  return (
    <UnstyledLink to={AppRouting.NewAnalysis.path()}>
      <Button startAdornment={<AddListIcon />}>{t(Resources.Common.NewAnalysis)}</Button>
    </UnstyledLink>
  );
};
